import { PaymentWorkflowType } from '../components/container/forms/types/api/graph.types';
import { createInitialFormState } from '../components/container/forms/hooks/useFormState';
import type { FormState } from '../components/container/forms/types/core/form-state.types';
import { getWorkflowSectionKeys } from '../types';
import {
  isWorkflowPermissionsBypassed,
  workflowsRegistry,
} from './workflowRegistry';

// ============= Constants =============

export const TESTING_DUMMY_WORKFLOW_ID_PREFIX = 'dummy-testing-';

export const PERMISSION_OVERWRITE_BANNER_TEXT =
  'Permission overwrite, no backend connected, ONLY FOR TESTING PURPOSES';

// ============= Helpers =============

export const getTestingDummyWorkflowId = (registryId: string): string =>
  `${TESTING_DUMMY_WORKFLOW_ID_PREFIX}${registryId}`;

export const isTestingDummyWorkflowId = (
  id: string | number | undefined | null
): boolean => String(id ?? '').startsWith(TESTING_DUMMY_WORKFLOW_ID_PREFIX);

export const shouldBypassWorkflowBackend = (
  workflowType: PaymentWorkflowType | undefined | null
): boolean =>
  workflowType != null &&
  workflowType !== PaymentWorkflowType.Undefined &&
  isWorkflowPermissionsBypassed(workflowType);

export const shouldBypassWorkflowBackendByKey = (
  workflowKey: string | undefined | null
): boolean => {
  if (!workflowKey) return false;
  return workflowsRegistry[workflowKey]?.permissions === true;
};

export const buildTestingDummyFormState = (
  workflowType: PaymentWorkflowType,
  options: { id: string; name: string }
): FormState => {
  const initialState = createInitialFormState(workflowType);
  const sectionKeys = getWorkflowSectionKeys(workflowType);
  const firstSection = sectionKeys[0] ?? initialState.currentSection;

  return {
    ...initialState,
    isLoading: false,
    currentSection: firstSection,
    data: {
      ...initialState.data,
      id: options.id,
      name: options.name,
      currentAuthStage: firstSection,
      createdDate: new Date().toISOString(),
      createdByName: 'Local test user',
      userAssignedSections: sectionKeys,
    },
  };
};
